import { useState } from 'react';

export default function useReviewModalData() {
  const [reviewsVisible, setReviewsVisible] = useState(false);
  const [data, setData] = useState({});

  const openModal = (item: any) => {
    setData(item);
    toggleModal();
  };

  const toggleModal = () => {
    setReviewsVisible(!reviewsVisible);
  };

  return {
    reviewsVisible,
    setReviewsVisible,
    data,
    setData,
    toggleModal,
    openModal,
  };
}
